/**
 * "A new version is ready" notice: shown (outside a run) once the server has
 * issued a ticket for newer game rules than this page's bundle. Runs still
 * work meanwhile, as unranked offline runs; reloading picks up the new bundle
 * so runs can be ranked again. Polite and dismissible: it never covers the
 * game or blocks a button.
 */
import { useT } from '../i18n/index.ts';
import { Button, IconButton } from './Button.tsx';
import { Icon } from './Icon.tsx';
import './ui.css';

export interface UpdateNoticeProps {
  onReload(): void;
  onDismiss(): void;
}

export function UpdateNotice({ onReload, onDismiss }: UpdateNoticeProps) {
  const t = useT();
  return (
    <div className="ui-update" role="status">
      <Icon name="refresh" className="ui-update__icon" />
      <p className="ui-update__text">{t('shell.updateAvailable')}</p>
      <Button variant="primary" icon="refresh" onClick={onReload}>
        {t('shell.updateReload')}
      </Button>
      <IconButton icon="close" variant="ghost" label={t('common.close')} onClick={onDismiss} />
    </div>
  );
}
